import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

import { actions as basketActions } from 'src/redux/basket/slice';
import { getBasketForViewing, populateOptionValuesFromBasketItem } from 'src/redux/basket/thunks';

export const useEditProductOptions = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();

  const retrieveEditItem = async () => {
    await dispatch(populateOptionValuesFromBasketItem(query.editItem as string));
    dispatch(basketActions.setOptionsExpanded({ expanded: true }));
  };

  useEffect(() => {
    if (query.editItem) {
      retrieveEditItem();
    } else {
      dispatch(getBasketForViewing());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.editItem]);
};
